import { useEffect, type RefObject } from 'react';
import { roundTo } from '@optimization/ssi-common';
import { type UpdateQueryParameterValues } from '../../../../hooks/use-update-query-parameter-values';
import drawPieChart, { type PieChartItem } from '@/utils/draw-pie-chart';
import { type SelectedChartSegment } from '@/app/config/chart-segments';

interface UseRenderPieChartProperties {
  chartRef: RefObject<HTMLDivElement | null>;
  items: PieChartItem[];
  selectedSegment: SelectedChartSegment | null;
  indexKey: string;
  searchParameters: URLSearchParams;
  updateQueryParameterValues: UpdateQueryParameterValues;
  onSegmentClick: (item: PieChartItem) => void;
}

const useRenderPieChart = ({
  chartRef,
  items,
  selectedSegment,
  indexKey,
  searchParameters,
  updateQueryParameterValues,
  onSegmentClick,
}: UseRenderPieChartProperties): void => {
  useEffect(() => {
    if (!chartRef.current) return;

    drawPieChart({
      element: chartRef.current,
      chartItems: items.map((item) => ({
        ...item,
        value: roundTo(item.value, 0),
      })),
      selectedSegment,
      indexKey,
      onSegmentClick,
    });
  }, [chartRef, items, selectedSegment, indexKey, searchParameters, updateQueryParameterValues, onSegmentClick]);
};
export default useRenderPieChart;
